import { SearchTermsPicker } from './SearchTermsPicker';
import { SEARCH_TERMS_DESCRIPTION } from '../utils/searchTermsCopy';
import styles from './SearchTermsSection.module.css';

/** The practice-facing search-terms card. Auto-saves the Search Console suggestions when the location
 *  has no set yet — not gated on Search Console being connected here — which is what lets the agency
 *  hire Sam there. */
export function SearchTermsSection({ locationId }: { locationId: string }) {
  return (
    <section aria-label="Search terms">
      <h2 className={styles.title}>Search terms</h2>
      <p className={styles.description}>{SEARCH_TERMS_DESCRIPTION}</p>
      {/* key={locationId} forces a full remount on location switch, so a previous location's unsaved
          draft can never be carried over and saved onto the newly-selected location. */}
      <SearchTermsPicker key={locationId} locationId={locationId} autoSaveSuggestions />
    </section>
  );
}
